import React from "react";

const Filter = ({filter, setFilter, setSort}) => {
  return (
    <div className="filter">
      <h2>Filtrar: </h2>
      <div className="filter-options">
        <div>
          <p>Status:</p>
          <select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option value="All">Todas</option>
            <option value="Completed">Completas</option>
            <option value="Incomplete">Incompletas</option>
          </select>
        </div>
        <div>
          <p>Ordenar: </p>
          <button onClick={() => setSort("Priority")}>Prioridade</button>
          <button onClick={() => setSort("Date")}>Data</button>
        </div>
      </div>
    </div>
  );
};

export default Filter;
